import script from "./Whatsapp.vue?vue&type=script&setup=true&lang=js"
export * from "./Whatsapp.vue?vue&type=script&setup=true&lang=js"

import "./Whatsapp.vue?vue&type=style&index=0&id=58bcb128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58bcb128"]])

export default __exports__